module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper list-item"
  }, [(_vm.item) ? _c('div', [_c('div', {
    staticClass: "campaign-holder"
  }, [_c('div', {
    staticClass: "campaign-container"
  }, [_c('p', {
    class: {
      unpaired: !_vm.item.step2_campaign_id
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.step1_campaign_id) + " - " + _vm._s(_vm.item.step1_campaign_name))])]), _vm._v(" "), (_vm.item.step2_campaign_id) ? _c('p', [_c('span', [_vm._v(_vm._s(_vm.item.step2_campaign_id) + " - " + _vm._s(_vm.item.step2_campaign_name))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "vertical-container"
  }, [_c('p', {
    staticClass: "vertical-content"
  }, [_vm._v(_vm._s(_vm.item.vertical))])])]), _vm._v(" "), _c('div', {
    staticClass: "row summary-container"
  }, [_c('div', {
    staticClass: "stats"
  }, [_c('el-badge', {
    staticClass: "item s1",
    attrs: {
      "value": _vm.item.step1_sales || '0',
      "max": 9999
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("S1 Sales")])], 1), _vm._v(" "), _c('el-badge', {
    staticClass: "item s2",
    attrs: {
      "value": _vm.item.step2_sales || '0',
      "max": 9999
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("S2 Sales")])], 1), _vm._v(" "), _c('el-badge', {
    staticClass: "item epc",
    attrs: {
      "value": '$' + parseFloat(_vm.item.blended_epc || 0).toFixed(2),
      "max": 100
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("EPC")])], 1)], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.item) ? _c('div', [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "campaign-holder"
  }, [_c('div', {
    staticClass: "campaign-container no-results"
  }, [_c('p', [_c('span', [_vm._v("Sorry!")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("No Campaigns Available")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-325d5764","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-list-item.vue
// module id = fYhv
// module chunks = 1